/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockStorageFeeListResVo
 */
export interface StockStorageFeeListResVo {
    /**
     * 费用归属日期
     * @type {string}
     * @memberof StockStorageFeeListResVo
     */
    feeDate?: string;
    /**
     * 库存仓库名称
     * @type {string}
     * @memberof StockStorageFeeListResVo
     */
    warehouseName?: string;
    /**
     * 账单编号
     * @type {string}
     * @memberof StockStorageFeeListResVo
     */
    billCode?: string;
    /**
     * 计费箱数
     * @type {number}
     * @memberof StockStorageFeeListResVo
     */
    skuCount?: number;
    /**
     * 商品总数
     * @type {number}
     * @memberof StockStorageFeeListResVo
     */
    totalItemQty?: number;
    /**
     * 库存商品体积，如 10.2CBM
     * @type {string}
     * @memberof StockStorageFeeListResVo
     */
    totalCbmText?: string;
    /**
     * 当日保管费（韩币）
     * @type {number}
     * @memberof StockStorageFeeListResVo
     */
    dailyStorageFee?: number;
}

/**
 * Check if a given object implements the StockStorageFeeListResVo interface.
 */
export function instanceOfStockStorageFeeListResVo(value: object): value is StockStorageFeeListResVo {
    return true;
}

export function StockStorageFeeListResVoFromJSON(json: any): StockStorageFeeListResVo {
    return StockStorageFeeListResVoFromJSONTyped(json, false);
}

export function StockStorageFeeListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockStorageFeeListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'feeDate': json['feeDate'] == null ? undefined : json['feeDate'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'billCode': json['billCode'] == null ? undefined : json['billCode'],
        'skuCount': json['skuCount'] == null ? undefined : json['skuCount'],
        'totalItemQty': json['totalItemQty'] == null ? undefined : json['totalItemQty'],
        'totalCbmText': json['totalCbmText'] == null ? undefined : json['totalCbmText'],
        'dailyStorageFee': json['dailyStorageFee'] == null ? undefined : json['dailyStorageFee'],
    };
}

export function StockStorageFeeListResVoToJSON(json: any): StockStorageFeeListResVo {
    return StockStorageFeeListResVoToJSONTyped(json, false);
}

export function StockStorageFeeListResVoToJSONTyped(value?: StockStorageFeeListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feeDate': value['feeDate'],
        'warehouseName': value['warehouseName'],
        'billCode': value['billCode'],
        'skuCount': value['skuCount'],
        'totalItemQty': value['totalItemQty'],
        'totalCbmText': value['totalCbmText'],
        'dailyStorageFee': value['dailyStorageFee'],
    };
}

